import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, retry, switchMap, tap } from 'rxjs';
import { EMPTY, of } from 'rxjs';
import * as liteRegPvrRedirectActions from '../actions/pvr-redirect.actions';
import { PvrCookieEncryptionService } from '../../services/pvr-redirect/pvr-cookie-encryption.service';
import { environment } from 'src/environments/environment';
import { LoggerService } from '../../services/logger/logger.service';
import { extractErrorMessage } from '../../../common/utils/common.util';

@Injectable({
    providedIn: 'root',
})
export class LiteRegRedirectApiEffect {
    private readonly actions$ = inject(Actions);
    private readonly pvrCookieEncryptionService = inject(PvrCookieEncryptionService);
    private loggerService = inject(LoggerService);


    liteRegPvrRedirect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(liteRegPvrRedirectActions.LiteRegRedirect),
            switchMap((action) =>
                this.pvrCookieEncryptionService.encryptPvrCookie(action.token).pipe(
                    retry(3),
                    tap(() => {
                        window.location.href = environment.PVR_LITE_REG_REDIRECT_URL;
                    }),
                    // No action dispatched on success
                    switchMap(() => EMPTY),
                    catchError((error: HttpErrorResponse) => {
                        this.loggerService.error(
                            `Lite Reg PVR Redirect Error:, ${extractErrorMessage(error)}`,
                        );
                        return of(liteRegPvrRedirectActions.LiteRegRedirectError({ error }));
                    }),
                ),
            ),
        ),
    );
}
